import React, { useState, useCallback } from 'react'
import { I18n } from 'react-redux-i18n'

import IntegrationAppAPI from 'api/integrationApp'
import SaveToastNotification from 'utils/toasts/SaveToastNotification'
import InputText from 'components/forms/InputText'
import Textarea from 'components/forms/Textarea'
import Button from 'components/forms/Button'

/**
 * Form edit app
 * @param {object} props
 * @param {object} props.app
 * @param {function} props.setApp
 *
 * @returns {React.Component}
 */
const FormEditAPP = (props) => {
  const { app, setApp } = props

  const [state, setState] = useState({
    name: app.name,
    description: app.description
  })
  const [errors, setErrors] = useState({ name: '' })
  const [inProgress, setInProgress] = useState(false)
  const [disabled, setDisabled] = useState(true)

  const onSubmit = useCallback(
    async (target, state) => {
      try {
        setInProgress(true)

        const result = await IntegrationAppAPI.updateById({ ...state, identifier: app._id })

        setApp(state => ({ ...state, name: result.name, description: result.description }))

        setDisabled(true)
        setInProgress(false)
        setErrors({ name: '' })

        SaveToastNotification.ok()
      } catch (error) {
        if (error?.field === 'name') {
          setErrors(state => ({
            ...state,
            name: I18n.t(error.type)
          }))

          target.name.focus()
        }

        setInProgress(false)

        SaveToastNotification.error()
      }

    }, [app._id]
  )

  return (
    <form
      className='integrations-app-edit__form'
      onSubmit={(e) => {
        e.preventDefault()

        onSubmit(e.target, state)
      }}
    >
      <InputText
        required
        displayEdit={disabled}
        title={I18n.t('integration_app_name')}
        htmlFor='name'
        value={state.name}
        onChange={(text) => {
          setState({ ...state, name: text })

          if (errors.name) setErrors({ ...errors, name: '' })
        }}
        disabled={disabled}
        onClickEdit={() => setDisabled(false)}
        minLength={5}
        error={errors.name}
      />

      <Textarea
        required
        title={I18n.t('integration_app_description')}
        htmlFor='description'
        value={state.description}
        onChange={(text) => setState({ ...state, description: text })}
        minLength={5}
        disabled={disabled}
      />

      <div className='integrations-app-edit__form-buttons'>
        {
          disabled
            ? null
            : (
              <>
                <Button
                  label={I18n.t('dashboard_cancel')}
                  color='secondary'
                  disabled={inProgress}
                  onClick={() => {
                    setDisabled(true)
                    setState({
                      name: app.name,
                      description: app.description
                    })
                  }}
                />
                <Button
                  label={I18n.t('dashboard_save')}
                  className='integrations-app-edit__form-buttons-save'
                  disabled={inProgress}
                  type='submit'
                />
              </>
            )
        }
      </div>
    </form>
  )
}

export default FormEditAPP
